import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import db from "./Firebase";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import * as XLSX from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function AllAppointments() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [userPhoneMap, setUserPhoneMap] = useState({});

    const fetchFilteredData = async () => {
        if (!startDate || !endDate) return;

        const startTimestamp = moment(startDate).startOf('day').toDate();
        const endTimestamp = moment(endDate).endOf('day').toDate();

        const snapshot = await db.collection("nv_create_booking")
            .where("created_date", ">=", startTimestamp)
            .where("created_date", "<=", endTimestamp)
            .orderBy("created_date", "desc")
            .get();

        const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
        }));

        setData(fetchedData);

        // collect unique usernames
        const usernames = [...new Set(fetchedData.map(({ data }) => data.username).filter(Boolean))];

        // Firestore "in" supports max 10 items — batch into chunks
        const phoneMap = {};
        for (let i = 0; i < usernames.length; i += 10) {
            const chunk = usernames.slice(i, i + 10);
            const pSnap = await db.collection("personal_details").where("username", "in", chunk).get();
            pSnap.docs.forEach((doc) => {
                const d = doc.data();
                if (d.username) phoneMap[d.username] = d.phone_no || "";
            });
        }
        setUserPhoneMap(phoneMap);
    };

    const exportToExcel = () => {
        const formattedData = data.map(({ data }) => ({
            Username: data.username,
            "Booked By (Phone)": userPhoneMap[data.username] || "",
            "Parlour Name": data.business_name,
            "Customer Name": `${data.customer_phone} || ${data.customer_name}`,
            "Service Name": data.services?.length > 0 ? data.services.join(", ") : "No Services",
            "Service Category": data.category,
            "Created Date": moment(data.created_date.toDate()).format("MM/DD/YY, h:mm a"),
            "App. Date": `${moment(data.date).format("MM/DD/YY")} || ${data.time}`,
            "Status": data.status == "0" ? "Pending" : data.status == "1" ? "Completed" : data.status == "2" ? "Cancelled" : "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
        XLSX.writeFile(workbook, "Booked_Appointments.xlsx");
    };

    return (
        <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
                <button className="btn bg-gradient-secondary btn-sm text-white" onClick={exportToExcel}>Download Excel</button>

            </div>

            <div className="p-3">
                <div className="card p-3">
                    <h6 className="mb-3">Booked Appointments</h6>
                    <div className="d-flex align-items-center gap-3">
                        <label>Start Date:</label>
                        <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" />
                        <label>End Date:</label>
                        <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} className="form-control" />
                        <button className="btn btn-primary" style={{ width: "20rem", marginTop: "1rem" }} onClick={fetchFilteredData}>Filter</button>
                    </div>
                </div>

                {data.length > 0 && (
                    <div className="table-responsive mt-3">
                        <table className="table table-bordered table-hover">
                            <thead className="thead-dark">
                                <tr>
                                    <th>Username</th>
                                    <th>Booked By</th>
                                    <th>Parlour Name</th>
                                    <th>Customer Name</th>
                                    <th>Service Category</th>
                                    <th>Service Name</th>
                                    <th>Created Date</th>
                                    <th>App. Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(({ id, data }) => (
                                    <tr key={id}>
                                        <td>{data.username}</td>
                                        <td>{userPhoneMap[data.username] || "-"}</td>
                                        <td>{data.business_name}</td>
                                        <td>{data.customer_phone} || {data.customer_name}</td>
                                        <td>{data.category}</td>
                                        <td>{data.services?.length > 0 ? data.services.join(", ") : "No Services"}</td>
                                        <td>{moment(data.created_date.toDate()).format("MM/DD/YY, h:mm a")}</td>
                                        <td>{moment(data.date).format("MM/DD/YY")} || {data.time}</td>
                                        <td>
                                            <span
                                                className={`text-xs mb-0 ${data.status == "0" ? "text-warning" :
                                                    data.status == "1" ? "text-success" :
                                                        data.status == "2" ? "text-danger" : ""
                                                    }`}
                                            >
                                                {data.status == "0" ? "Pending" : data.status == "1" ? "Completed" : data.status == "2" ? "Cancelled" : ""}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </main>
    );
}

export default AllAppointments;



// import React, { useState, useEffect } from 'react';

// import { useNavigate, Link } from 'react-router-dom';
// import db from "./Firebase";
// import Moment from 'moment';
// import { extendMoment } from 'moment-range';
// import * as XLSX from 'xlsx';

// function AllAppointments() {
//     const moment = extendMoment(Moment);
//     const [data, setData] = useState([]);
//     const [dataLimit, setDataLimit] = useState(20);

//     useEffect(() => {
//         db.collection("nv_create_booking").orderBy("created_date", "desc").onSnapshot((snapshot) => {
//             const fetchedData = snapshot.docs.map((doc) => ({
//                 id: doc.id,
//                 data: doc.data(),
//             }));
//             setData(fetchedData);
//         });
//     }, []);

//     const limitedData = data.slice(0, dataLimit);

//     const loadMoreData = () => {
//         setDataLimit(dataLimit + 20);
//     };

//     const exportToExcel = () => {
//         const formattedData = data.map(({ data }) => ({
//             Username: data.username,
//             "Parlour Name": data.business_name,
//             "Customer Name": `${data.customer_phone} || ${data.customer_name}`,
//             "Service Name": `${data.services && data.services.length > 0 ? data.services.join(", ") : "No Services"}`,
//             "Service Category": `${data.category}`,
//             "Created Date": moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a"),
//             "App. Date": `${moment(data.date).format("MM/DD/YY")} || ${data.time}`,
//             "Status": `${data.status == "0" ? "Pending" : data.status == "1" ? "Completed" : data.status == "2" ? "Cancelled" : ""}`,
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(formattedData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
//         XLSX.writeFile(workbook, "Booked_Appointments.xlsx");
//     };

//     return (
//         <>
//             <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//                 <div className="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
//                     <span
//                         className="btn bg-gradient-secondary btn-sm mb-0 mr-2"
//                         style={{ color: "white", cursor: "pointer" }}
//                         onClick={exportToExcel}
//                     >
//                         &nbsp; Download Excel
//                     </span>
//                     <Link to="/">
//                         <img
//                             src="/images/menubutton.png"
//                             className="menu-toggle"
//                             alt="Responsive"
//                             style={{ height: "2rem" }}
//                         />
//                     </Link>
//                 </div>
//                 <div className="2">
//                     <div className="p-2">
//                         <div className="card">
//                             <div className="card-header pb-0 px-3">
//                                 <h6 className="mb-2">Booked Appointment</h6>
//                             </div>
//                             <div className="">
//                                 <div className="card">
//                                     <div className="table-responsive fix-width scroll-inner">
//                                         <table className="table table-bordered table-hover">
//                                             <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                                                 <tr style={{ textAlign: "left" }}>
//                                                     <th className="ps-2">Username</th>
//                                                     <th className="ps-2">Parlour Name</th>
//                                                     <th className="">Customer Name</th>
//                                                     <th className="ps-2">Service Category</th>
//                                                     <th className="ps-2">Service Name</th>
//                                                     <th className="ps-2">Created Date</th>
//                                                     <th className="ps-2">App. Date</th>
//                                                     <th className="ps-2">Status</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody style={{ textAlign: "left" }}>
//                                                 {limitedData.map(({ id, data }, index) => (
//                                                     <tr key={id}>
//                                                         <td>
//                                                             <span style={{ color: "black" }} className="mb-0">{data.username}</span>
//                                                         </td>
//                                                         <td>
//                                                             <span className="text-xs mb-0">{data.business_name}</span>
//                                                         </td>
//                                                         <td>
//                                                             <span className="text-xs mb-0">{data.customer_phone} || {data.customer_name}</span>
//                                                         </td>
//                                                         <td>
//                                                             <span className="text-xs mb-0">{data.category}</span>
//                                                         </td>
//                                                         <td>
//                                                             {data.services && data.services.length > 0 ? (
//                                                                 data.services.map((service, index) => (
//                                                                     <span key={index} className="text-xs mb-0">
//                                                                         {service}{index !== data.services.length - 1 ? ', ' : ''}
//                                                                     </span>
//                                                                 ))
//                                                             ) : (
//                                                                 <span className="text-xs mb-0">No Services</span>
//                                                             )}
//                                                         </td>


//                                                         <td>
//                                                             <span className="text-xs mb-0">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span>
//                                                         </td>
//                                                         <td>
//                                                             <span className="text-xs mb-0">{moment(data.date).format("MM/DD/YY")} || {data.time}</span>
//                                                         </td>
//                                                         <td>
//                                                             <span
//                                                                 className={`text-xs mb-0 ${data.status == "0" ? "text-warning" :
//                                                                     data.status == "1" ? "text-success" :
//                                                                         data.status == "2" ? "text-danger" : ""
//                                                                     }`}
//                                                             >
//                                                                 {data.status == "0" ? "Pending" : data.status == "1" ? "Completed" : data.status == "2" ? "Cancelled" : ""}
//                                                             </span>
//                                                         </td>
//                                                     </tr>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                     <div className="" style={{ paddingTop: "2rem" }}>
//                                         <button onClick={loadMoreData} className="btn btn-dark">Load More</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </main>
//         </>
//     );
// }

// export default AllAppointments;


// // import React, { useState, useEffect } from 'react';

// // import { useNavigate, Link } from 'react-router-dom';
// // import db from "./Firebase";
// // import Moment from 'moment';
// // import { extendMoment } from 'moment-range';

// // function AllAppointments() {
// //     const moment = extendMoment(Moment);
// //     const [data, setData] = useState([]);
// //     const [dataLimit, setDataLimit] = useState(20);

// //     useEffect(() => {
// //         db.collection("appointments_data").orderBy("date", "desc").onSnapshot((snapshot) => {
// //             const fetchedData = snapshot.docs.map((doc) => ({
// //                 id: doc.id,
// //                 data: doc.data(),
// //             }));
// //             setData(fetchedData);
// //         });
// //     }, []);

// //     const limitedData = data.slice(0, dataLimit);

// //     const loadMoreData = () => {
// //         setDataLimit(dataLimit + 20);
// //     };

// //     return (
// //         <>
// //             <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
// //                 <div className="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
// //                     <Link to="/"><img src="/images/menubutton.png" className="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>
// //                 </div>
// //                 <div className="2">
// //                     <div className="p-2">
// //                         <div className="card">
// //                             <div className="card-header pb-0 px-3">
// //                                 <h6 className="mb-2">Booked Appointment</h6>
// //                             </div>
// //                             <div className="">
// //                                 <div className="card">
// //                                     <div className="table-responsive fix-width scroll-inner">
// //                                         <table className="table table-bordered table-hover">
// //                                             <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// //                                                 <tr style={{ textAlign: "left" }}>
// //                                                     <th className="ps-2">Username</th>
// //                                                     <th className="ps-2">Parlour Name</th>
// //                                                     <th className="">Customer Name</th>
// //                                                     <th className="ps-2">Created Date</th>
// //                                                     <th className="ps-2">App. Date</th>
// //                                                 </tr>
// //                                             </thead>
// //                                             <tbody style={{ textAlign: "left" }}>
// //                                                 {limitedData.map(({ id, data }, index) => (
// //                                                     <tr key={id}>
// //                                                         <td>
// //                                                             <span style={{ color: "black" }} className="mb-0">{data.username}</span>
// //                                                         </td>
// //                                                         <td>
// //                                                             <span className="text-xs mb-0">{data.parlour}</span>
// //                                                         </td>
// //                                                         <td>
// //                                                             <span className="text-xs mb-0">{data.phone} || {data.name}</span>
// //                                                         </td>
// //                                                         <td>
// //                                                             <span className="text-xs mb-0">{moment(data.date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span>
// //                                                         </td>
// //                                                         <td>
// //                                                             <span className="text-xs mb-0">{moment(data.booked_date.toDate().toISOString()).format("MM/DD/YY")} || {data.time}</span>
// //                                                         </td>
// //                                                     </tr>
// //                                                 ))}
// //                                             </tbody>
// //                                         </table>

// //                                     </div>
// //                                     <div className="" style={{ paddingTop: "2rem" }}>
// //                                         <button onClick={loadMoreData} className="btn btn-dark">Load More</button>
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </main>
// //         </>
// //     );
// // }

// // export default AllAppointments;


// // // import React, { useState, useEffect } from 'react';

// // // import { useNavigate, Link, useParams } from 'react-router-dom';
// // // import db from "./Firebase";
// // // import firebaseApp from "./Firebase";
// // // import { arrayUnion } from "firebase/firestore";
// // // import { storage } from './Firebase';
// // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // import Moment from 'moment';
// // // import { extendMoment } from 'moment-range';
// // // import ViewAllRequests from './ViewAllRequests';
// // // import ViewAppData from './ViewAppData';
// // // import { CSVLink } from "react-csv";

// // // function AllAppointments() {
// // //     const moment = extendMoment(Moment);
// // //     const [data, setData] = useState([]);

// // //     useEffect(() => {
// // //         db.collection("appointments_data").orderBy("date", "desc").onSnapshot((snapshot) => {

// // //             setData(
// // //                 snapshot.docs.map((doc) => ({
// // //                     id: doc.id,
// // //                     data: doc.data(),
// // //                 }))
// // //             );

// // //         });

// // //     }, []);

// // //     return (
// // //         <>
// // //             {/* <ViewAppData /> */}
// // //             <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
// // //                 <div class="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
// // //                     {/* <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span> */}
// // //                     <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

// // //                 </div>
// // //                 <div class="2">


// // //                     <div class="p-2">

// // //                         <div class="card">
// // //                             <div class="card-header pb-0 px-3">
// // //                                 <h6 class="mb-2">Booked Appointment</h6>
// // //                             </div>
// // //                             <div class="">
// // //                                 <div class="card">
// // //                                     <div class="table-responsive fix-width scroll-inner">
// // //                                         <table class="table table-bordered table-hover">
// // //                                             <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
// // //                                                 <tr style={{ textAlign: "left" }}>
// // //                                                     <th class=" ps-2">Username</th>
// // //                                                     <th class=" ps-2">Parlour Name</th>
// // //                                                     <th class="">Customer Name</th>
// // //                                                     {/* <th class=" ps-2">Customer Phone No.</th> */}
// // //                                                     <th class=" ps-2">Created Date</th>
// // //                                                     <th class=" ps-2">App. Date</th>
// // //                                                 </tr>
// // //                                             </thead>
// // //                                             <tbody style={{ textAlign: "left" }}>
// // //                                                 {data?.map(({ id, data }, index) => (
// // //                                                     <>
// // //                                                         <tr>

// // //                                                             <td>
// // //                                                                 <span style={{ color: "black" }} class="mb-0">{data.username}</span>
// // //                                                                 {/* <span class="text-xs text-secondary mb-0">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span> */}
// // //                                                             </td>
// // //                                                             <td>
// // //                                                                 <span class="text-xs mb-0">{data.parlour}</span>
// // //                                                                 {/* <span class="text-xs text-secondary mb-0">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span> */}
// // //                                                             </td>
// // //                                                             <td>
// // //                                                                 <span class="text-xs mb-0">{data.phone} || {data.name}</span>
// // //                                                                 {/* <span class="text-xs text-secondary mb-0">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span> */}
// // //                                                             </td>
// // //                                                             {/* <td>
// // //                                                                 <span class="text-xs mb-0">{data.phone}</span>
// // //                                                                 <span class="text-xs text-secondary mb-0">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span>
// // //                                                             </td> */}
// // //                                                             <td>
// // //                                                                 <span class="text-xs mb-0">{moment(data.date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span>
// // //                                                                 {/* <span class="text-xs text-secondary mb-0">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span> */}
// // //                                                             </td>
// // //                                                             <td>
// // //                                                                 <span class="text-xs mb-0">{moment(data.booked_date.toDate().toISOString()).format("MM/DD/YY")} || {data.time}</span>
// // //                                                                 {/* <span class="text-xs text-secondary mb-0">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span> */}
// // //                                                             </td>



// // //                                                         </tr>

// // //                                                     </>
// // //                                                 ))}


// // //                                             </tbody>
// // //                                         </table>
// // //                                     </div>
// // //                                 </div>
// // //                             </div>
// // //                         </div>
// // //                     </div>

// // //                 </div>

// // //             </main>


// // //         </>
// // //     )
// // // }

// // // export default AllAppointments;